import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import ElderCareSupportDetails from '../../subdepartmentdetails/ElderCareSupport'


function ElderCareSupport() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Elder Care Support and Resources || Senior Services";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Senior Services"
            title="Elder Care Support"
            subtitledown="Department of Senior Services"
           />
            <ElderCareSupportDetails/>
        </div>
    </>
  )
}

export default ElderCareSupport